import styled, { useTheme } from "styled-components";
import { Avatar, Badge, Card, Icon, Text } from "~/components-shared";
import React from "react";
import { useDrag, useDrop } from "react-dnd";
import { NoPanArea } from "react-zoomable-ui";
import { AuthoritiesEnum, RoutesEnum } from "~/types/enums";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import memberTreeActionCreators from "~/store/memberTree/actions";
import useAbacExt from "~/hooks/abac";
import authSelectors from "~/store/auth/selectors";
const Drop = styled.div`
  display: inline-block;
`;
const Drag = styled.div`
  display: inline-block;
`;
const StyledCard = styled(Card)`
  display: inline-flex;
  min-width: 180px;
  max-width: 180px;
  ${_ref => {
  let {
    $canDrag
  } = _ref;
  return $canDrag && "cursor: move;";
}}

  opacity: ${_ref2 => {
  let {
    $dragging
  } = _ref2;
  return $dragging ? 0.4 : 1;
}};

  ${_ref3 => {
  let {
    $isOver,
    $canDrop,
    theme
  } = _ref3;
  const isActive = $canDrop && $isOver;
  if (isActive) {
    return `background-color: ${theme.colors.success.secondary}`;
  }
  if ($canDrop) {
    return `background-color: ${theme.colors.warning.secondary}`;
  }
  return "";
}};
`;
const StyledAvatar = styled(Avatar)`
  z-index: 2;
`;
const Content = styled.div`
  flex-grow: 1;
`;
const OrgChartMemberCard = _ref4 => {
  let {
    treeItem: {
      member,
      children
    }
  } = _ref4;
  const {
    colors
  } = useTheme();
  const {
    userHas
  } = useAbacExt();
  const history = useHistory();
  const user = useSelector(authSelectors.getUser);
  const dispatch = useDispatch();
  const [{
    isDragging
  }, drag] = useDrag({
    type: "member",
    item: {
      id: member.id
    },
    end: (item, monitor) => {
      const dropResult = monitor.getDropResult();
      if (item && dropResult && item.id !== dropResult.id) {
        dispatch(memberTreeActionCreators.updateStarted(item.id, dropResult.id));
      }
    },
    collect: monitor => ({
      isDragging: monitor.isDragging()
    }),
    canDrag: userHas(AuthoritiesEnum.ORG_CHART_WRITE)
  });
  const [{
    canDrop,
    isOver
  }, drop] = useDrop({
    accept: "member",
    drop: () => ({
      id: member.id
    }),
    collect: monitor => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop()
    }),
    canDrop: item => {
      return item.id !== member.id;
    }
  });
  const handleClick = () => {
    history.push(user.id === member.id ? RoutesEnum.PROFILE : RoutesEnum.MEMBER.replace(":memberId", member.id));
  };
  return /*#__PURE__*/React.createElement(Drop, {
    ref: drop
  }, /*#__PURE__*/React.createElement(NoPanArea, null, /*#__PURE__*/React.createElement(Drag, {
    ref: drag
  }, /*#__PURE__*/React.createElement(StyledCard, {
    border: true,
    align: "center",
    minHeight: "18rem",
    $dragging: isDragging,
    $canDrag: userHas(AuthoritiesEnum.ORG_CHART_WRITE),
    $isOver: isOver,
    $canDrop: canDrop,
    onClick: handleClick
  }, /*#__PURE__*/React.createElement(StyledAvatar, {
    user: member,
    size: 18,
    color: colors.primary.main,
    s: {
      mb: 4,
      mt: 6
    },
    showStatus: true,
    showEmoji: true
  }), /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(Text, {
    display: "block",
    weight: "semiBold",
    color: colors.primary.main
  }, member.role.name), /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    fontSize: 4.5,
    lineHeight: 6
  }, member.firstName, " ", member.lastName), member.pronouns && /*#__PURE__*/React.createElement(Text, {
    element: "span",
    color: "textSecondary",
    fontSize: 3
  }, member.position)), children && /*#__PURE__*/React.createElement(Badge, {
    color: "grey"
  }, /*#__PURE__*/React.createElement(Text, {
    element: "span",
    color: "textSecondary",
    weight: "semiBold"
  }, /*#__PURE__*/React.createElement(Icon, {
    src: "people",
    s: {
      mr: 1
    }
  }), children.length))))));
};
export default OrgChartMemberCard;